import { createEvent } from 'effector';
import { type ProcessingMode } from './model';

export const setProcessingMode = createEvent<ProcessingMode>();
